var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { size: "mini" },
              on: { click: _vm.goBack },
            },
            [_vm._v("返回")]
          ),
          _vm.isSupplier &&
          (_vm.recordForm.status === "SUBMITTED" ||
            _vm.recordForm.status === "OBSOLETED") &&
          !_vm.editable
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doEdit },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
          _vm.isSupplier && _vm.recordForm.status === "DRAFT"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doSave },
                },
                [_vm._v("保存并计算")]
              )
            : _vm._e(),
          _vm.isSupplier &&
          (_vm.recordForm.status === "DRAFT" ||
            ((_vm.recordForm.status === "SUBMITTED" ||
              _vm.recordForm.status === "OBSOLETED") &&
              _vm.editable))
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doSubmit },
                },
                [_vm._v("提交")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "process__record__card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "line" }),
                _c("span", [_vm._v("基本信息")]),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "recordFormRef",
              attrs: {
                model: _vm.recordForm,
                rules: _vm.baseRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "生产日期", prop: "parentBatchNo" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "mandatory" }, [
                              _vm._v("生产日期"),
                            ]),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: _vm.$t("common.selDate"),
                              disabled:
                                !_vm.editable ||
                                _vm.recordForm.status === "SUBMITTED",
                            },
                            model: {
                              value: _vm.recordForm.parentBatchNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "parentBatchNo", $$v)
                              },
                              expression: "recordForm.parentBatchNo",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "小批次数量", prop: "subBatchNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "20",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.subBatchNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "subBatchNumber", $$v)
                              },
                              expression: "recordForm.subBatchNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.recordForm.keyConfig === "GRIASL"
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "ASL", prop: "aslName" } },
                            [
                              _c("template", { slot: "label" }, [
                                _c("span", { staticClass: "mandatory" }, [
                                  _vm._v("ASL"),
                                ]),
                              ]),
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled:
                                      !_vm.editable ||
                                      _vm.recordForm.status === "SUBMITTED",
                                  },
                                  model: {
                                    value: _vm.recordForm.aslName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.recordForm, "aslName", $$v)
                                    },
                                    expression: "recordForm.aslName",
                                  },
                                },
                                [
                                  _vm.editable &&
                                  _vm.recordForm.status !== "SUBMITTED"
                                    ? _c("el-button", {
                                        attrs: {
                                          slot: "append",
                                          icon: "el-icon-search",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectAsl(
                                              null,
                                              null,
                                              "BASE"
                                            )
                                          },
                                        },
                                        slot: "append",
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工厂", prop: "plantName" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "mandatory" }, [
                              _vm._v("工厂"),
                            ]),
                          ]),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                readonly: "",
                                disabled:
                                  !_vm.editable ||
                                  _vm.recordForm.status === "SUBMITTED",
                              },
                              model: {
                                value: _vm.recordForm.plantName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.recordForm, "plantName", $$v)
                                },
                                expression: "recordForm.plantName",
                              },
                            },
                            [
                              _vm.editable && _vm.recordForm.status === "DRAFT"
                                ? _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      icon: "el-icon-search",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.showPlanDialog = true
                                      },
                                    },
                                    slot: "append",
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "版本号", prop: "version" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.version,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "version", $$v)
                              },
                              expression: "recordForm.version",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "comments" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "2",
                              maxlength: "500",
                              disabled: !_vm.editable,
                            },
                            model: {
                              value: _vm.recordForm.comments,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "comments", $$v)
                              },
                              expression: "recordForm.comments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "GRI编码", prop: "griCode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.griCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "griCode", $$v)
                              },
                              expression: "recordForm.griCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "GRI名称", prop: "griName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.griName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "griName", $$v)
                              },
                              expression: "recordForm.griName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category2", prop: "category2" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.category2Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "category2Name", $$v)
                              },
                              expression: "recordForm.category2Name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商", prop: "supplierName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.supplierName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "supplierName", $$v)
                              },
                              expression: "recordForm.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "制成总数", prop: "processNumber" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.processNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "processNumber", $$v)
                              },
                              expression: "recordForm.processNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "statusI18n" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.statusI18n,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "statusI18n", $$v)
                              },
                              expression: "recordForm.statusI18n",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category3", prop: "category3" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.category3Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "category3Name", $$v)
                              },
                              expression: "recordForm.category3Name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间", prop: "createDate" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "createDate", $$v)
                              },
                              expression: "recordForm.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人", prop: "createUserName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.createUserName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "createUserName", $$v)
                              },
                              expression: "recordForm.createUserName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新时间", prop: "updateDate" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.updateDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "updateDate", $$v)
                              },
                              expression: "recordForm.updateDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "更新人", prop: "updateUserName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              maxlength: "50",
                              disabled: "",
                            },
                            model: {
                              value: _vm.recordForm.updateUserName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordForm, "updateUserName", $$v)
                              },
                              expression: "recordForm.updateUserName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "process__record__card process__body" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                },
              },
              [
                _c("div", { staticClass: "title" }, [
                  _c("span", { staticClass: "line" }),
                  _c("span", [_vm._v("制成汇总")]),
                ]),
              ]
            ),
          ]
        ),
        _c("div", { staticStyle: { display: "flex", "min-height": "400px" } }, [
          _c(
            "div",
            {
              staticStyle: {
                width: "350px",
                "border-right": "1px solid #EEEEEE",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "10px", "overflow-y": "auto" },
                },
                [
                  _vm._l(_vm.recordForm.processes, function (item, index) {
                    return [
                      item.display !== "none"
                        ? _c(
                            "div",
                            {
                              staticClass: "process__item",
                              class: {
                                selected:
                                  item.tplProcessId ===
                                  _vm.selectedProcess.tplProcessId,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.doSelectProcess(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "baseline",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "circle__default" },
                                        [_vm._v(_vm._s(index + 1))]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "15px",
                                            "font-size": "14px",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.processName))]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "circle__small" }, [
                                    _vm._v(_vm._s(item.factors.length)),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
          _c(
            "div",
            {
              ref: "factorRef",
              staticStyle: {
                width: "calc(100% - 350px)",
                "overflow-y": "auto",
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "factorFormRef",
                  staticClass: "factor__form",
                  attrs: { model: _vm.recordForm },
                },
                _vm._l(_vm.factorList, function (factor) {
                  return _c(
                    "div",
                    { staticStyle: { margin: "15px", "border-radius": "5px" } },
                    [
                      factor.inputMode === "SINGLE"
                        ? _c(
                            "el-card",
                            {
                              staticClass: "process__record__card factor__card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("div", { staticClass: "title" }, [
                                    _c("span", { staticClass: "line" }),
                                    _c("span", [
                                      _vm._v(_vm._s(factor.factorName)),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { padding: "10px" } },
                                _vm._l(
                                  _vm.groupedParams(factor.params),
                                  function (row, rIndex) {
                                    return _c(
                                      "el-row",
                                      { key: rIndex, attrs: { gutter: 20 } },
                                      _vm._l(row, function (param, index) {
                                        return (
                                          _vm.isSupplier
                                            ? param.supplierViewable
                                            : true
                                        )
                                          ? _c(
                                              "el-col",
                                              { attrs: { span: 6 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "single__",
                                                    attrs: {
                                                      label: `${
                                                        param.paramName
                                                      }${
                                                        param.standard
                                                          ? `(${param.standard})`
                                                          : ""
                                                      }${
                                                        param.uom
                                                          ? `/${param.uom}`
                                                          : ""
                                                      }`,
                                                      prop: `${param.tplParamId}`,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "label" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            class: {
                                                              mandatory:
                                                                param.required,
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  param.paramName
                                                                )
                                                              ),
                                                            ]),
                                                            param.standard &&
                                                            param.standardType !=
                                                              "SINGLE"
                                                              ? _c("span", [
                                                                  _vm._v("("),
                                                                ])
                                                              : _vm._e(),
                                                            param.standardType !=
                                                            "SINGLE"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      param.standard
                                                                        ? param.standard
                                                                        : ""
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            param.standard &&
                                                            param.standardType !=
                                                              "SINGLE"
                                                              ? _c("span", [
                                                                  _vm._v(")"),
                                                                ])
                                                              : _vm._e(),
                                                            param.uom
                                                              ? _c("span", [
                                                                  _vm._v("/"),
                                                                ])
                                                              : _vm._e(),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  param.uom
                                                                    ? param.uom
                                                                    : ""
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        param.paramDesc
                                                          ? _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    param.paramDesc,
                                                                  placement:
                                                                    "top",
                                                                  "popper-class":
                                                                    "prod__record",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-info param__tip",
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    param.dataType === "TEXT" &&
                                                    (_vm.isSupplier
                                                      ? param.supplierViewable
                                                      : true)
                                                      ? _c("el-input", {
                                                          class: {
                                                            invalid__:
                                                              _vm.checkStandardValue(
                                                                param,
                                                                param[
                                                                  param
                                                                    .tplParamId
                                                                ],
                                                                "SINGLE"
                                                              ),
                                                          },
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              param.paramType ===
                                                                "STATISTIC" ||
                                                              !_vm.editable,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleProcessVisible(
                                                                param,
                                                                param.tplParamId,
                                                                "SINGLE"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              param[
                                                                param.tplParamId
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                param,
                                                                param.tplParamId,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "param[param.tplParamId]",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    param.dataType === "DATE" &&
                                                    (_vm.isSupplier
                                                      ? param.supplierViewable
                                                      : true)
                                                      ? _c("el-date-picker", {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            type: "date",
                                                            placeholder:
                                                              _vm.$t(
                                                                "common.selDate"
                                                              ),
                                                            disabled:
                                                              param.paramType ===
                                                                "STATISTIC" ||
                                                              !_vm.editable,
                                                          },
                                                          model: {
                                                            value:
                                                              param[
                                                                param.tplParamId
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                param,
                                                                param.tplParamId,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "param[param.tplParamId]",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    param.dataType ===
                                                      "NUMBER" &&
                                                    (_vm.isSupplier
                                                      ? param.supplierViewable
                                                      : true)
                                                      ? _c("el-input", {
                                                          class: {
                                                            invalid__:
                                                              _vm.checkStandardValue(
                                                                param,
                                                                param[
                                                                  param
                                                                    .tplParamId
                                                                ],
                                                                "SINGLE"
                                                              ),
                                                          },
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              param.paramType ===
                                                                "STATISTIC" ||
                                                              !_vm.editable,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleInput(
                                                                param,
                                                                param.tplParamId,
                                                                "SINGLE"
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.calcSpecialParamRequired(
                                                                param,
                                                                param[
                                                                  param
                                                                    .tplParamId
                                                                ],
                                                                85
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              param[
                                                                param.tplParamId
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                param,
                                                                param.tplParamId,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "param[param.tplParamId]",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    param.dataType ===
                                                      "BOOLEAN" &&
                                                    (_vm.isSupplier
                                                      ? param.supplierViewable
                                                      : true)
                                                      ? _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                param.paramType ===
                                                                  "STATISTIC" ||
                                                                !_vm.editable,
                                                            },
                                                            model: {
                                                              value:
                                                                param[
                                                                  param
                                                                    .tplParamId
                                                                ],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    param,
                                                                    param.tplParamId,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "param[param.tplParamId]",
                                                            },
                                                          },
                                                          [
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "Y",
                                                                value: "1",
                                                              },
                                                            }),
                                                            _c("el-option", {
                                                              attrs: {
                                                                label: "N",
                                                                value: "0",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    param.dataType ===
                                                    "SELECTOR"
                                                      ? _c(
                                                          "el-input",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                param.paramType ===
                                                                  "STATISTIC" ||
                                                                !_vm.editable,
                                                              readonly:
                                                                param.selectorType ===
                                                                "ASL",
                                                            },
                                                            model: {
                                                              value:
                                                                param[
                                                                  param
                                                                    .tplParamId
                                                                ],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    param,
                                                                    param.tplParamId,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "param[param.tplParamId]",
                                                            },
                                                          },
                                                          [
                                                            param.selectorType ===
                                                              "ASL" &&
                                                            _vm.editable
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      slot: "append",
                                                                      icon: "el-icon-search",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.selectAsl(
                                                                            param,
                                                                            param.tplParamId,
                                                                            "SINGLE"
                                                                          )
                                                                        },
                                                                    },
                                                                    slot: "append",
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    param.dataType === "DICT"
                                                      ? _c("ic-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            table:
                                                              param.dictTable,
                                                            field:
                                                              param.dictField,
                                                            clearable: "",
                                                            disabled:
                                                              param.paramType ===
                                                                "STATISTIC" ||
                                                              !_vm.editable,
                                                          },
                                                          model: {
                                                            value:
                                                              param[
                                                                param.tplParamId
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                param,
                                                                param.tplParamId,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "param[param.tplParamId]",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }),
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      factor.inputMode === "LIST"
                        ? _c(
                            "el-card",
                            {
                              staticClass: "process__record__card factor__card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "title" }, [
                                        _c("span", { staticClass: "line" }),
                                        _c("span", [
                                          _vm._v(_vm._s(factor.factorName)),
                                        ]),
                                      ]),
                                      _vm.editable
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addParam(factor)
                                                },
                                              },
                                            },
                                            [_vm._v("新增行")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { margin: "10px" } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: factor.dataList,
                                        border: "",
                                      },
                                    },
                                    [
                                      _vm.groupedColumns(factor).length == 1 &&
                                      !_vm.hasEmptyCategory(factor)
                                        ? _vm._l(
                                            factor.params,
                                            function (column) {
                                              return (
                                                _vm.isSupplier
                                                  ? column.supplierViewable
                                                  : true
                                              )
                                                ? _c("el-table-column", {
                                                    key: column.tplParamId,
                                                    attrs: {
                                                      prop: column.tplParamId,
                                                      label: column.paramName,
                                                      "min-width":
                                                        _vm.calcMinWidth(
                                                          column.paramName,
                                                          column.standard,
                                                          column.uom
                                                        ),
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "header",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: {
                                                                    mandatory:
                                                                      column.required,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        column.paramName
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  column.standard &&
                                                                  column.standardType !=
                                                                    "SINGLE"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "("
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  column.standardType !=
                                                                  "SINGLE"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              column.standard
                                                                                ? column.standard
                                                                                : ""
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  column.standard &&
                                                                  column.standardType !=
                                                                    "SINGLE"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            ")"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  column.uom
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "/"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        column.uom
                                                                          ? column.uom
                                                                          : ""
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              column.paramDesc
                                                                ? _c(
                                                                    "el-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        effect:
                                                                          "dark",
                                                                        content:
                                                                          column.paramDesc,
                                                                        placement:
                                                                          "top",
                                                                        "popper-class":
                                                                          "prod__record",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "el-icon-info param__tip",
                                                                      }),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "el-form-item",
                                                                [
                                                                  column.dataType ===
                                                                  "TEXT"
                                                                    ? _c(
                                                                        "el-input",
                                                                        {
                                                                          class:
                                                                            {
                                                                              invalid__:
                                                                                _vm.checkStandardValue(
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap[
                                                                                    column
                                                                                      .tplParamId
                                                                                  ],
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap[
                                                                                    column
                                                                                      .tplParamId
                                                                                  ]
                                                                                    .paramValue,
                                                                                  "LIST"
                                                                                ),
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  column.dataType ===
                                                                  "DATE"
                                                                    ? _c(
                                                                        "el-date-picker",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              width:
                                                                                "100%",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              type: "date",
                                                                              "value-format":
                                                                                "yyyy-MM-dd",
                                                                              placeholder:
                                                                                _vm.$t(
                                                                                  "common.selDate"
                                                                                ),
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  column.dataType ===
                                                                  "NUMBER"
                                                                    ? _c(
                                                                        "el-input",
                                                                        {
                                                                          class:
                                                                            {
                                                                              invalid__:
                                                                                _vm.checkStandardValue(
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap[
                                                                                    column
                                                                                      .tplParamId
                                                                                  ],
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap[
                                                                                    column
                                                                                      .tplParamId
                                                                                  ]
                                                                                    .paramValue,
                                                                                  "LIST"
                                                                                ),
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.handleInput(
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap,
                                                                                  column.tplParamId,
                                                                                  "LIST"
                                                                                )
                                                                              },
                                                                            blur: function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.calcSpecialParamRequiredList(
                                                                                scope
                                                                                  .row
                                                                                  .dataMap,
                                                                                column.tplParamId,
                                                                                85
                                                                              )
                                                                            },
                                                                          },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  column.dataType ===
                                                                  "BOOLEAN"
                                                                    ? _c(
                                                                        "el-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  label:
                                                                                    "Y",
                                                                                  value:
                                                                                    "1",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "el-option",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  label:
                                                                                    "N",
                                                                                  value:
                                                                                    "0",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  column.dataType ===
                                                                  "SELECTOR"
                                                                    ? _c(
                                                                        "el-input",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                              readonly:
                                                                                column.selectorType ===
                                                                                "ASL",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        },
                                                                        [
                                                                          column.selectorType ===
                                                                            "ASL" &&
                                                                          _vm.editable
                                                                            ? _c(
                                                                                "el-button",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      slot: "append",
                                                                                      icon: "el-icon-search",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.selectAsl(
                                                                                          scope
                                                                                            .row
                                                                                            .dataMap[
                                                                                            column
                                                                                              .tplParamId
                                                                                          ],
                                                                                          null,
                                                                                          "LIST"
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                  slot: "append",
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  column.dataType ===
                                                                  "DICT"
                                                                    ? _c(
                                                                        "ic-select",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              width:
                                                                                "100%",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              table:
                                                                                column.dictTable,
                                                                              field:
                                                                                column.dictField,
                                                                              clearable:
                                                                                "",
                                                                              disabled:
                                                                                column.paramType ===
                                                                                  "STATISTIC" ||
                                                                                !_vm.editable,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                scope
                                                                                  .row
                                                                                  .dataMap[
                                                                                  column
                                                                                    .tplParamId
                                                                                ]
                                                                                  .paramValue,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    scope
                                                                                      .row
                                                                                      .dataMap[
                                                                                      column
                                                                                        .tplParamId
                                                                                    ],
                                                                                    "paramValue",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                : _vm._e()
                                            }
                                          )
                                        : [
                                            _vm._l(
                                              _vm.groupedColumns(factor),
                                              function (
                                                categoryGroup,
                                                categoryIndex
                                              ) {
                                                return [
                                                  categoryGroup.category
                                                    ? _c(
                                                        "el-table-column",
                                                        {
                                                          key:
                                                            "category-" +
                                                            categoryIndex +
                                                            "-" +
                                                            factor.factorId,
                                                          attrs: {
                                                            label:
                                                              categoryGroup.category,
                                                          },
                                                        },
                                                        _vm._l(
                                                          categoryGroup.columns,
                                                          function (column) {
                                                            return (
                                                              _vm.isSupplier
                                                                ? column.supplierViewable
                                                                : true
                                                            )
                                                              ? _c(
                                                                  "el-table-column",
                                                                  {
                                                                    key: column.tplParamId,
                                                                    attrs: {
                                                                      prop: column.tplParamId,
                                                                      label:
                                                                        column.paramName,
                                                                      "min-width":
                                                                        _vm.calcMinWidth(
                                                                          column.paramName,
                                                                          column.standard,
                                                                          column.uom
                                                                        ),
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "header",
                                                                            fn: function (
                                                                              scope
                                                                            ) {
                                                                              return [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    class:
                                                                                      {
                                                                                        mandatory:
                                                                                          column.required,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            column.paramName
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    column.standard &&
                                                                                    column.standardType !=
                                                                                      "SINGLE"
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "("
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.standardType !=
                                                                                    "SINGLE"
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                column.standard
                                                                                                  ? column.standard
                                                                                                  : ""
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.standard &&
                                                                                    column.standardType !=
                                                                                      "SINGLE"
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              ")"
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.uom
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "/"
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            column.uom
                                                                                              ? column.uom
                                                                                              : ""
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                column.paramDesc
                                                                                  ? _c(
                                                                                      "el-tooltip",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            effect:
                                                                                              "dark",
                                                                                            content:
                                                                                              column.paramDesc,
                                                                                            placement:
                                                                                              "top",
                                                                                            "popper-class":
                                                                                              "prod__record",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-info param__tip",
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            },
                                                                          },
                                                                          {
                                                                            key: "default",
                                                                            fn: function (
                                                                              scope
                                                                            ) {
                                                                              return [
                                                                                _c(
                                                                                  "el-form-item",
                                                                                  [
                                                                                    column.dataType ===
                                                                                    "TEXT"
                                                                                      ? _c(
                                                                                          "el-input",
                                                                                          {
                                                                                            class:
                                                                                              {
                                                                                                invalid__:
                                                                                                  _vm.checkStandardValue(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ]
                                                                                                      .paramValue,
                                                                                                    "LIST"
                                                                                                  ),
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.dataType ===
                                                                                    "DATE"
                                                                                      ? _c(
                                                                                          "el-date-picker",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                width:
                                                                                                  "100%",
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                type: "date",
                                                                                                "value-format":
                                                                                                  "yyyy-MM-dd",
                                                                                                placeholder:
                                                                                                  _vm.$t(
                                                                                                    "common.selDate"
                                                                                                  ),
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.dataType ===
                                                                                    "NUMBER"
                                                                                      ? _c(
                                                                                          "el-input",
                                                                                          {
                                                                                            class:
                                                                                              {
                                                                                                invalid__:
                                                                                                  _vm.checkStandardValue(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ]
                                                                                                      .paramValue,
                                                                                                    "LIST"
                                                                                                  ),
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                              },
                                                                                            on: {
                                                                                              input:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.handleInput(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap,
                                                                                                    column.tplParamId,
                                                                                                    "LIST"
                                                                                                  )
                                                                                                },
                                                                                              blur: function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.calcSpecialParamRequiredList(
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap,
                                                                                                  column.tplParamId,
                                                                                                  85
                                                                                                )
                                                                                              },
                                                                                            },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.dataType ===
                                                                                    "BOOLEAN"
                                                                                      ? _c(
                                                                                          "el-select",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    label:
                                                                                                      "Y",
                                                                                                    value:
                                                                                                      "1",
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "el-option",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    label:
                                                                                                      "N",
                                                                                                    value:
                                                                                                      "0",
                                                                                                  },
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.dataType ===
                                                                                    "SELECTOR"
                                                                                      ? _c(
                                                                                          "el-input",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                                readonly:
                                                                                                  column.selectorType ===
                                                                                                  "ASL",
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            column.selectorType ===
                                                                                              "ASL" &&
                                                                                            _vm.editable
                                                                                              ? _c(
                                                                                                  "el-button",
                                                                                                  {
                                                                                                    attrs:
                                                                                                      {
                                                                                                        slot: "append",
                                                                                                        icon: "el-icon-search",
                                                                                                      },
                                                                                                    on: {
                                                                                                      click:
                                                                                                        function (
                                                                                                          $event
                                                                                                        ) {
                                                                                                          return _vm.selectAsl(
                                                                                                            scope
                                                                                                              .row
                                                                                                              .dataMap[
                                                                                                              column
                                                                                                                .tplParamId
                                                                                                            ],
                                                                                                            null,
                                                                                                            "LIST"
                                                                                                          )
                                                                                                        },
                                                                                                    },
                                                                                                    slot: "append",
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e(),
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    column.dataType ===
                                                                                    "DICT"
                                                                                      ? _c(
                                                                                          "ic-select",
                                                                                          {
                                                                                            staticStyle:
                                                                                              {
                                                                                                width:
                                                                                                  "100%",
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                table:
                                                                                                  column.dictTable,
                                                                                                field:
                                                                                                  column.dictField,
                                                                                                clearable:
                                                                                                  "",
                                                                                                disabled:
                                                                                                  column.paramType ===
                                                                                                    "STATISTIC" ||
                                                                                                  !_vm.editable,
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      scope
                                                                                                        .row
                                                                                                        .dataMap[
                                                                                                        column
                                                                                                          .tplParamId
                                                                                                      ],
                                                                                                      "paramValue",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                              },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    : _vm._l(
                                                        categoryGroup.columns,
                                                        function (
                                                          column,
                                                          colIndex
                                                        ) {
                                                          return (
                                                            _vm.isSupplier
                                                              ? column.supplierViewable
                                                              : true
                                                          )
                                                            ? _c(
                                                                "el-table-column",
                                                                {
                                                                  key:
                                                                    column.tplParamId +
                                                                    "-" +
                                                                    colIndex,
                                                                  attrs: {
                                                                    prop: column.tplParamId,
                                                                    label:
                                                                      column.paramName,
                                                                    "min-width":
                                                                      _vm.calcMinWidth(
                                                                        column.paramName,
                                                                        column.standard,
                                                                        column.uom
                                                                      ),
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "header",
                                                                          fn: function (
                                                                            scope
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  class:
                                                                                    {
                                                                                      mandatory:
                                                                                        column.required,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          column.paramName
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  column.standard &&
                                                                                  column.standardType !=
                                                                                    "SINGLE"
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "("
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.standardType !=
                                                                                  "SINGLE"
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              column.standard
                                                                                                ? column.standard
                                                                                                : ""
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.standard &&
                                                                                  column.standardType !=
                                                                                    "SINGLE"
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            ")"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.uom
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "/"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          column.uom
                                                                                            ? column.uom
                                                                                            : ""
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              column.paramDesc
                                                                                ? _c(
                                                                                    "el-tooltip",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          effect:
                                                                                            "dark",
                                                                                          content:
                                                                                            column.paramDesc,
                                                                                          placement:
                                                                                            "top",
                                                                                          "popper-class":
                                                                                            "prod__record",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "i",
                                                                                        {
                                                                                          staticClass:
                                                                                            "el-icon-info param__tip",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          },
                                                                        },
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            scope
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "el-form-item",
                                                                                [
                                                                                  column.dataType ===
                                                                                  "TEXT"
                                                                                    ? _c(
                                                                                        "el-input",
                                                                                        {
                                                                                          class:
                                                                                            {
                                                                                              invalid__:
                                                                                                _vm.checkStandardValue(
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ],
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                  "LIST"
                                                                                                ),
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.dataType ===
                                                                                  "DATE"
                                                                                    ? _c(
                                                                                        "el-date-picker",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              width:
                                                                                                "100%",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              type: "date",
                                                                                              "value-format":
                                                                                                "yyyy-MM-dd",
                                                                                              placeholder:
                                                                                                _vm.$t(
                                                                                                  "common.selDate"
                                                                                                ),
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.dataType ===
                                                                                  "NUMBER"
                                                                                    ? _c(
                                                                                        "el-input",
                                                                                        {
                                                                                          class:
                                                                                            {
                                                                                              invalid__:
                                                                                                _vm.checkStandardValue(
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ],
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap[
                                                                                                    column
                                                                                                      .tplParamId
                                                                                                  ]
                                                                                                    .paramValue,
                                                                                                  "LIST"
                                                                                                ),
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.handleInput(
                                                                                                  scope
                                                                                                    .row
                                                                                                    .dataMap,
                                                                                                  column.tplParamId,
                                                                                                  "LIST"
                                                                                                )
                                                                                              },
                                                                                            blur: function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.calcSpecialParamRequiredList(
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap,
                                                                                                column.tplParamId,
                                                                                                85
                                                                                              )
                                                                                            },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.dataType ===
                                                                                  "BOOLEAN"
                                                                                    ? _c(
                                                                                        "el-select",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "el-option",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  label:
                                                                                                    "Y",
                                                                                                  value:
                                                                                                    "1",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                          _c(
                                                                                            "el-option",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  label:
                                                                                                    "N",
                                                                                                  value:
                                                                                                    "0",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.dataType ===
                                                                                  "SELECTOR"
                                                                                    ? _c(
                                                                                        "el-input",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                              readonly:
                                                                                                column.selectorType ===
                                                                                                "ASL",
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          column.selectorType ===
                                                                                            "ASL" &&
                                                                                          _vm.editable
                                                                                            ? _c(
                                                                                                "el-button",
                                                                                                {
                                                                                                  attrs:
                                                                                                    {
                                                                                                      slot: "append",
                                                                                                      icon: "el-icon-search",
                                                                                                    },
                                                                                                  on: {
                                                                                                    click:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.selectAsl(
                                                                                                          scope
                                                                                                            .row
                                                                                                            .dataMap[
                                                                                                            column
                                                                                                              .tplParamId
                                                                                                          ],
                                                                                                          null,
                                                                                                          "LIST"
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                  slot: "append",
                                                                                                }
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  column.dataType ===
                                                                                  "DICT"
                                                                                    ? _c(
                                                                                        "ic-select",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              width:
                                                                                                "100%",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              table:
                                                                                                column.dictTable,
                                                                                              field:
                                                                                                column.dictField,
                                                                                              clearable:
                                                                                                "",
                                                                                              disabled:
                                                                                                column.paramType ===
                                                                                                  "STATISTIC" ||
                                                                                                !_vm.editable,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                scope
                                                                                                  .row
                                                                                                  .dataMap[
                                                                                                  column
                                                                                                    .tplParamId
                                                                                                ]
                                                                                                  .paramValue,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    scope
                                                                                                      .row
                                                                                                      .dataMap[
                                                                                                      column
                                                                                                        .tplParamId
                                                                                                    ],
                                                                                                    "paramValue",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "scope.row.dataMap[column.tplParamId].paramValue",
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                ]
                                              }
                                            ),
                                          ],
                                      _vm.editable
                                        ? _c("el-table-column", {
                                            key: "op",
                                            attrs: {
                                              label: "操作",
                                              width: "80",
                                              fixed: "right",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-delete",
                                                        staticStyle: {
                                                          color: "red",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteParam(
                                                              factor,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      factor.inputMode === "TABLE"
                        ? _c(
                            "el-card",
                            {
                              staticClass: "process__record__card factor__card",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "title" }, [
                                        _c("span", { staticClass: "line" }),
                                        _c("span", [
                                          _vm._v(_vm._s(factor.factorName)),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: factor.dataList,
                                        border: "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        key: "pn",
                                        attrs: {
                                          prop: "paramName",
                                          label: "参数",
                                          "min-width": "150",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.paramName
                                                      )
                                                    ),
                                                  ]),
                                                  scope.row.standard &&
                                                  scope.row.standardType !=
                                                    "SINGLE"
                                                    ? _c("span", [_vm._v("(")])
                                                    : _vm._e(),
                                                  scope.row.standardType !=
                                                  "SINGLE"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.standard
                                                              ? scope.row
                                                                  .standard
                                                              : ""
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  scope.row.standard &&
                                                  scope.row.standardType !=
                                                    "SINGLE"
                                                    ? _c("span", [_vm._v(")")])
                                                    : _vm._e(),
                                                  scope.row.uom
                                                    ? _c("span", [_vm._v("/")])
                                                    : _vm._e(),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.uom
                                                          ? scope.row.uom
                                                          : ""
                                                      )
                                                    ),
                                                  ]),
                                                  scope.row.paramDesc
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            effect: "dark",
                                                            content:
                                                              scope.row
                                                                .paramDesc,
                                                            placement: "top",
                                                            "popper-class":
                                                              "prod__record",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info param__tip",
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _vm._l(
                                        factor.columns,
                                        function (column, index) {
                                          return _c("el-table-column", {
                                            key: index,
                                            attrs: {
                                              label: column.columnName,
                                              "min-width": "140",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function (scope) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            column.columnName
                                                          ) +
                                                          " "
                                                      ),
                                                      column.columnDesc
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  column.columnDesc,
                                                                placement:
                                                                  "top",
                                                                "popper-class":
                                                                  "prod__record",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-info param__tip",
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          scope.row.dataType ===
                                                          "TEXT"
                                                            ? _c("el-input", {
                                                                class: {
                                                                  invalid__:
                                                                    _vm.checkStandardValue(
                                                                      scope.row,
                                                                      scope.row
                                                                        .dataMap[
                                                                        column
                                                                          .tplColumnId
                                                                      ],
                                                                      "TABLE"
                                                                    ),
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    scope.row
                                                                      .paramType ===
                                                                      "STATISTIC" ||
                                                                    !_vm.editable,
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .dataMap[
                                                                      column
                                                                        .tplColumnId
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope
                                                                          .row
                                                                          .dataMap,
                                                                        column.tplColumnId,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.dataMap[column.tplColumnId]",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          scope.row.dataType ===
                                                          "DATE"
                                                            ? _c(
                                                                "el-date-picker",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                  },
                                                                  attrs: {
                                                                    type: "date",
                                                                    "value-format":
                                                                      "yyyy-MM-dd",
                                                                    placeholder:
                                                                      _vm.$t(
                                                                        "common.selDate"
                                                                      ),
                                                                    disabled:
                                                                      scope.row
                                                                        .paramType ===
                                                                        "STATISTIC" ||
                                                                      !_vm.editable,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .dataMap[
                                                                        column
                                                                          .tplColumnId
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope
                                                                            .row
                                                                            .dataMap,
                                                                          column.tplColumnId,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.dataMap[column.tplColumnId]",
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          scope.row.dataType ===
                                                          "NUMBER"
                                                            ? _c("el-input", {
                                                                class: {
                                                                  invalid__:
                                                                    _vm.checkStandardValue(
                                                                      scope.row,
                                                                      scope.row
                                                                        .dataMap[
                                                                        column
                                                                          .tplColumnId
                                                                      ],
                                                                      "TABLE"
                                                                    ),
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    scope.row
                                                                      .paramType ===
                                                                      "STATISTIC" ||
                                                                    !_vm.editable,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleInput(
                                                                        scope
                                                                          .row
                                                                          .dataMap,
                                                                        column.tplColumnId,
                                                                        "TABLE"
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .dataMap[
                                                                      column
                                                                        .tplColumnId
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope
                                                                          .row
                                                                          .dataMap,
                                                                        column.tplColumnId,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.dataMap[column.tplColumnId]",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          scope.row.dataType ===
                                                          "BOOLEAN"
                                                            ? _c(
                                                                "el-select",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      scope.row
                                                                        .paramType ===
                                                                        "STATISTIC" ||
                                                                      !_vm.editable,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .dataMap[
                                                                        column
                                                                          .tplColumnId
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope
                                                                            .row
                                                                            .dataMap,
                                                                          column.tplColumnId,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.dataMap[column.tplColumnId]",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-option",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Y",
                                                                        value:
                                                                          "1",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "el-option",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "N",
                                                                        value:
                                                                          "0",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          scope.row.dataType ===
                                                          "SELECTOR"
                                                            ? _c(
                                                                "el-input",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      scope.row
                                                                        .paramType ===
                                                                        "STATISTIC" ||
                                                                      !_vm.editable,
                                                                    readonly:
                                                                      scope.row
                                                                        .selectorType ===
                                                                      "ASL",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      scope.row
                                                                        .dataMap[
                                                                        column
                                                                          .tplColumnId
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          scope
                                                                            .row
                                                                            .dataMap,
                                                                          column.tplColumnId,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "scope.row.dataMap[column.tplColumnId]",
                                                                  },
                                                                },
                                                                [
                                                                  scope.row
                                                                    .selectorType ===
                                                                    "ASL" &&
                                                                  _vm.editable
                                                                    ? _c(
                                                                        "el-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              slot: "append",
                                                                              icon: "el-icon-search",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.selectAsl(
                                                                                  scope
                                                                                    .row
                                                                                    .dataMap,
                                                                                  column.tplColumnId,
                                                                                  "TABLE"
                                                                                )
                                                                              },
                                                                          },
                                                                          slot: "append",
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          scope.row.dataType ===
                                                          "DICT"
                                                            ? _c("ic-select", {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                },
                                                                attrs: {
                                                                  table:
                                                                    scope.row
                                                                      .dictTable,
                                                                  field:
                                                                    scope.row
                                                                      .dictField,
                                                                  clearable: "",
                                                                  disabled:
                                                                    scope.row
                                                                      .paramType ===
                                                                      "STATISTIC" ||
                                                                    !_vm.editable,
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .dataMap[
                                                                      column
                                                                        .tplColumnId
                                                                    ],
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope
                                                                          .row
                                                                          .dataMap,
                                                                        column.tplColumnId,
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.dataMap[column.tplColumnId]",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-card",
        { staticClass: "process__record__card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "line" }),
                _c("span", [_vm._v("操作日志")]),
              ]),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createDate",
                  label: "操作时间",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operatorCode",
                  label: "用户编码",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operatorName",
                  label: "用户名称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "action", label: "操作", "min-width": "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "comments",
                  label: "变更原因",
                  "min-width": "120",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "填写变更原因",
            visible: _vm.dialogVisible,
            width: "50",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "updateReasonFormRef",
              attrs: {
                model: _vm.updateReasonForm,
                rules: _vm.reasonRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    required: "",
                    label: "变更原因",
                    prop: "updateReason",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "textarea", maxlength: "500", rows: "4" },
                    model: {
                      value: _vm.updateReasonForm.updateReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateReasonForm, "updateReason", $$v)
                      },
                      expression: "updateReasonForm.updateReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "flex-end" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.confirmSubmitWithReason },
                },
                [_vm._v("确认提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("plantDialog", {
        attrs: {
          "is-show": _vm.showPlanDialog,
          scoped: true,
          "create-fun": _vm.onConfirmPlan,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.showPlanDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showPlanDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showPlanDialog = false
          },
        },
      }),
      _c("aslDialog", {
        attrs: { "is-show": _vm.showAslDialog, "create-fun": _vm.onConfirmAsl },
        on: {
          "update:isShow": function ($event) {
            _vm.showAslDialog = $event
          },
          "update:is-show": function ($event) {
            _vm.showAslDialog = $event
          },
          hideDialog: function ($event) {
            _vm.showAslDialog = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }